module.exports = __webpack_public_path__ + "index_assets/img/bg.a3eb4544.png";